module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-row', {
    attrs: {
      "justify": "center"
    }
  }, [_c('v-dialog', {
    attrs: {
      "width": "600px"
    },
    on: {
      "input": function($event) {
        return _vm.$emit('input')
      }
    },
    model: {
      value: (_vm.value),
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "grey lighten-2",
    attrs: {
      "primary-title": ""
    }
  }, [_c('span', {
    staticClass: "headline",
    staticStyle: {
      "font-size": "1.3rem!important"
    }
  }, [_vm._v("Total Submissions")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-icon', {
    on: {
      "click": _vm.close
    }
  }, [_vm._v("close")])], 1), _vm._v(" "), _c('v-card-text', {
    staticStyle: {
      "padding": "10px"
    }
  }, [_c('v-data-table', {
    key: _vm.dataTableKey,
    staticClass: "recognized-revenue-table elevation-1",
    attrs: {
      "dense": "",
      "headers": _vm.headers,
      "search": _vm.filter,
      "items": _vm.monthYearValues,
      "hide-default-footer": "",
      "items-per-page": -1
    },
    scopedSlots: _vm._u([{
      key: "item.month",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-start",
          staticStyle: {
            "min-width": "100px!important"
          }
        }, [(item.month) ? _c('span', [_vm._v(_vm._s(_vm.formatCurrentMonth(item.month)))]) : _vm._e()])]
      }
    }, {
      key: "item.amount",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-start",
          staticStyle: {
            "min-width": "100px!important"
          }
        }, [(item.amount) ? _c('span', [_vm._v(_vm._s(_vm._f("thousandSeprator")(item.amount)))]) : _vm._e()])]
      }
    }], null, true)
  }, [_vm._v(" "), _vm._v(" "), _c('template', {
    slot: "body.append"
  }, [_c('tr', [_c('th', {
    staticStyle: {
      "font-size": "14px"
    }
  }, [_c('b', [_vm._v("Total " + _vm._s(_vm.currentYear))])]), _vm._v(" "), _c('th', {
    staticStyle: {
      "font-size": "14px"
    }
  }, [_c('b', [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.totalAmount)))])])])])], 2)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-53a71053"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Campaign/BrandFactSheet/TotalSubmissionsModal.vue
// module id = 2127
// module chunks = 0